export default {
  paged: {
    select: 'id,name,isActive,scope,categories,created,updated,creator,modifier',
    searchSelect: ['name'],
    orderBy: 'name asc',
  },
};
